import { Box,  Card, CardContent, Stack } from "@mui/material";
import { useFormContext  } from "react-hook-form";
import { ReportScheduleRecipientType, ScheduledReportsFormType } from "../../ScheduledReportsEditorUtils";
import FormCheckbox from "../../../forms/form-checkbox/FormCheckbox";
import { Email } from "@mui/icons-material";

export type ScheduledReportsRecipientListItemProps = {
    item: ReportScheduleRecipientType,
    onSelected?: (value: boolean) => void;
}

export function ScheduledReportsRecipientListItem({
    item,
    onSelected
}: ScheduledReportsRecipientListItemProps) {

    const {
        watch,
    } = useFormContext<ScheduledReportsFormType>();    
    
    const [recipients] = watch(['recipients']);

    // we need the 'real' index of the item
    const index = recipients.findIndex(o => o.address === item.address);

    function onRecipientChanged(value: boolean) {

        onSelected && onSelected(value);
    }
                        
    function renderRecipient() {

            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: '1 1 auto'
                    }}>
                    <FormCheckbox
                        name={`recipients.${index}.selected`}
                        label={<Stack direction='row'><Email />  {item.address}</Stack>}
                        sx={{ 
                            marginRight: 0,
                            marginTop: 0,
                        }}
                        typographyProps={{
                            sx: {
                                fontSize: '.95rem',
                            }
                        }}
                        onChange={(_event, checked) => onRecipientChanged(checked)}

                        />
                </Box>
            );
    }

    return (
        <Card variant="outlined">
            <CardContent sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}>
                { renderRecipient() }
            </CardContent>
        </Card>
    );
}
